import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Download, X } from "lucide-react";

const DISMISS_KEY = "cd_pwa_dismissed_at";
const DISMISS_MS = 1000 * 60 * 60 * 24 * 14; // 14 days

export default function PwaInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY) || 0);
    if (Date.now() - dismissedAt < DISMISS_MS) return;

    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    const onInstalled = () => setVisible(false);
    window.addEventListener("beforeinstallprompt", onBip);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBip);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    try {
      await deferred.userChoice;
    } catch {
      /* noop */
    }
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-4 right-4 z-50 max-w-sm bg-primary text-primary-foreground rounded-lg shadow-lg border border-primary/30 p-4 pr-3 flex items-start gap-3 animate-fade-in"
      data-testid="pwa-install-prompt"
    >
      <div className="flex-1 min-w-0">
        <div className="font-semibold text-sm">Install Cabinet Depot</div>
        <div className="text-xs opacity-80 mt-0.5">
          Add to your home screen for one-tap access.
        </div>
        <div className="mt-3 flex gap-2">
          <Button
            size="sm"
            variant="secondary"
            onClick={install}
            data-testid="pwa-install-accept"
            className="gap-1.5"
          >
            <Download className="w-3.5 h-3.5" /> Install
          </Button>
          <Button
            size="sm"
            variant="ghost"
            onClick={dismiss}
            data-testid="pwa-install-dismiss"
            className="text-primary-foreground hover:bg-primary/80"
          >
            Not now
          </Button>
        </div>
      </div>
      <button
        onClick={dismiss}
        className="opacity-70 hover:opacity-100"
        aria-label="Dismiss"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
